import React, { AnchorHTMLAttributes } from 'react';

import styles from './styles.module.scss';

export type Props = Pick<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  'onClick' | 'href' | 'children'
>;

const SuggestionLink = ({ href, onClick, children }: Props) => {
  return (
    <a className={styles.suggestionLink} href={href} onClick={onClick}>
      {children}
    </a>
  );
};

export default SuggestionLink;
